import { Component, OnInit, Inject, Optional, ViewChild, AfterViewInit,ElementRef } from '@angular/core';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FiedappService } from 'src/app/_services/fiedapp.service';
import { EmployeeDetailsService } from 'src/app/_services/employee-details.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DatePipe } from "@angular/common";
import moment from "moment";
import * as XLSX from 'xlsx';
import { Map, NavigationControl, Marker } from "maplibre-gl";
import maplibregl from "maplibre-gl";
import * as FileSaver from 'file-saver'; 
import { Observable } from 'rxjs'; 

@Component({
  selector: 'app-device-reset',
  templateUrl: './device-reset.component.html',
  styleUrls: ['./device-reset.component.scss']
})
export class DeviceResetComponent  implements OnInit,AfterViewInit {

  @ViewChild(MatTable, { static: true }) table: MatTable<any> = Object.create(null);
  
  searchText: any;
  displayedColumns: string[] = ['EmpCode', 'Name','action'];
  dataSource = new MatTableDataSource();
  loading = false;
  deviceDetails: any;
  customdate = new FormControl(moment());
  formGroup: any;
  formBuilder: any;
  excel:any;
  codes:any;


  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);

  constructor(public dialog: MatDialog,public fiedappService:FiedappService,public employeeDetailsService:EmployeeDetailsService,public router:Router, private datePipe: DatePipe) {
     
  }
  

  
  ngOnInit() {
      
      this.formGroup = new FormGroup({
        code: new FormControl("", [Validators.required]),
      });
      this.getEmployeecode();
  }   

  getEmployeecode(){

    this.employeeDetailsService.getEmployeeDetails().subscribe(
      (response: any) => {
        if (response && response.msg && Array.isArray(response.msg)) {
          this.codes = response.msg;
          //console.log(this.codes);
        }
      },
      (error: any) => {
        console.error("Error fetching employee details:", error);
      }
    );
  }
  
  ngAfterViewInit() {
      this.dataSource.paginator = this.paginator;
  }

  onSubmit() {
    // Handle form submission
    if (this.formGroup.valid) {
      
      //console.log(this.formGroup.value);
      this.fiedappService.deviceResetdetails(this.formGroup.value)
      .subscribe(data => {
          //console.log(data);
          //let result = data['msg'];
          //this.excel = [...result]
          this.dataSource=data['msg'];
          // if(data['msg']=='failure'){
          //   this.dataSource =data[''];
          // }else{
          // this.dataSource=data['msg']; 
          // console.log(this.dataSource);
          // }
          
        });
     
    }
  }
  
  openDialog(action: any) {
    //console.log(action)
    if(confirm("Are you sure to delete "+action.code+" ?")) {

      
      //console.log("Implement delete functionality here");
      this.fiedappService.deleteEmployeeDetail(this.formGroup.value).subscribe(
        (response: any) => {
          if (response && response.msg && Array.isArray(response.msg)) {
            let data = response.msg;
            window.location.reload();
            return true;
          }
        },
        (error: any) => {
          console.error("Error fetching employee details:", error);
        }
      );
      
    }
  }


}

